import { useAuth } from '../context/AuthContext';
import ContactForm from '../components/ContactForm';

export default function Contact() {
  const { user } = useAuth();

  return (
    <div style={{ maxWidth: 560, margin: '0 auto', padding: '40px 24px' }}>
      <h1 style={{ fontSize: 28, fontWeight: 300, marginBottom: 8 }}>Contact us</h1>
      <p style={{ color: 'var(--ink-3)', fontSize: 15, marginBottom: 32 }}>
        Have a question or need help? We typically respond within a few hours.
      </p>
      <div style={{ background: 'var(--bg-card)', border: '1.5px solid var(--border)', borderRadius: 14, padding: 32 }}>
        <ContactForm
          userEmail={user?.email}
          userName={user?.full_name}
        />
      </div>
    </div>
  );
}
